import {
  GET_VERIFICATION_DATA_REQUEST,
  GET_VERIFICATION_DATA_SUCCESS,
  GET_VERIFICATION_DATA_FAILURE,
  SAVE_VERIFICATION_DATA_FAILURE,
  SAVE_VERIFICATION_DATA_SUCCESS,
  SAVE_VERIFICATION_DATA_REQUEST
} from './actions';

import _ from 'lodash';

import createReducer from 'state/createReducer';

const initialState = {
  request: false,
  data: {
    valid: false,
    email: '',
    name: '',
    role: ''
  },
  validation: {
    name: '',
    password: '',
    verifyPassword: ''
  }
}

const handlers = {

  [GET_VERIFICATION_DATA_REQUEST](state) {
    return {
      ...state,
      request: true
    }
  },

  [GET_VERIFICATION_DATA_SUCCESS](state, payload) {

    const data = {
      valid: _.get(payload, 'valid', false),
      email: _.get(payload, 'data.email', ''),
      name: _.get(payload, 'data.name', ''),
      role: _.get(payload, 'data.role', '')
    }


    return {
      ...state,
      request: false,
      data: data
    }
  },

  [GET_VERIFICATION_DATA_FAILURE](state) {
    return {
      ...state,
      request: false,
      data: {
        valid: false,
        name: '',
        email: ''
      }
    }
  },

  [SAVE_VERIFICATION_DATA_REQUEST](state) {
    return {
      ...state,
      request: false
    }
  },

  [SAVE_VERIFICATION_DATA_SUCCESS](state) {
    return {
      ...state,
      request: false
    }
  },

  [SAVE_VERIFICATION_DATA_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      validation: {
        name: _.get(payload, 'name', ''),
        password: _.get(payload, 'password', ''),
        verifyPassword: _.get(payload, 'verifyPassword', '')
      }
    }
  }

}

export default (state = initialState, action) => createReducer(state, action, handlers);
